export { default as InputLabel } from './InputLabel';
export type { InputLabelProps } from './types';
